import SurveyStatusCount from "./SurveyStatusCount";

export default SurveyStatusCount;
